const types = {
    SET_GGR: '[GGR] SET GGR',
    SET_OPERATION_REPLENISHMENT: '[GGR] SET OPERATIONS REPLENISHMENT', 
    SET_OPERATION_WITHDRAWAL: '[GGR] SET OPERATIONS WITHDRAWAL'
}

export {
    types
}